<template>
	<button
		type="button"
		:aria-label="
			properties.direction === 'previous'
				? tg('aria.scroll-left')
				: tg('aria.scroll-right')
		"
		class="ring-focus flex size-12 items-center justify-center rounded-full bg-gray-50 text-3xl outline-hidden hover:bg-gray-100 focus:bg-gray-100 active:bg-gray-200"
	>
		<slot></slot>
	</button>
</template>

<script lang="ts" setup>
const properties = defineProps<{
	direction?: string;
}>();

const {t: tg} = useI18n({useScope: "global"});
</script>
